import module from './module.js'

//Component
import './components/component.js'
import './components/agregar/component.js'
import './components/agregar/seleccionar/component.js'
import './components/agregar/configuracion/component.js'
import './components/agregar/confirmar/component.js'
import './components/filtros/component.js'
import './components/launcher/component.js'
import './components/lista/component.js'
import './components/lista/item/component.js'
import './components/lista/item/estatus/component.js'
import './components/lista/item/importes/component.js'
import './components/lista/item/revisiones/component.js'
//Routes
import './routes/sumario.js'
import './routes/sumarioAgregar.js'
//Services
import './services/NominasSumario.js'
import './services/NominasSumarioAgregar.js'
import './services/NominasProrrateo.js'
import './services/NominasPredeterminado.js'
import './services/NominasValidacion.js'
import './services/Catalogo/RegimenFiscal.js'
import './services/Catalogo/Monedas.js'
import './services/Catalogo/TipoNominas.js'
import './services/Catalogo/Esquema.js'
import './services/Catalogo/Empresas.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/sumario/index.js